import io from 'socket.io-client';
import {
  CONNECT_SOCKET,
  DISCONNECT_SOCKET,
  RECEIVE_TRANSACTION_UPDATE,
  SUBSCRIBE_TO_TRANSACTION,
  SUBSCRIBE_TO_ORGANIZATION,
  UNSUBSCRIBE,
  receiveTransactionUpdate
} from '../Helper/webSocketActions';

let socket;

export const socketMiddleware = store => next => action => {
  const user = store.getState().auth.user;
  const token = user?.accessToken
  const organizationId = user?.tenantId // Assuming this is for emitting to specific rooms, not for namespaces
  const userId = user?.userId

  switch (action.type) {
    case CONNECT_SOCKET:
      if (socket) {
        socket.disconnect();
      }

      // Step 2: Establish WebSocket connection without using namespace URL
      socket = io('/', {
        path: '/ws/',
        query: { token },
        transports: ['websocket', 'polling'] // Allow WebSocket upgrade explicitly
      });

      // Step 3: Handle successful connection
      socket.on('connect', () => {
        console.log('Connected to WebSocket server');
      });

      // Step 4: Handle connection error (useful for debugging CORS or other issues)
      socket.on('connect_error', err => {
        console.error('Connection error:', err.message);
      });

      socket.on('connect_timeout', () => {
        console.error('Connection timed out');
      });

      socket.on('disconnect', reason => {
        console.log('Disconnected from WebSocket server:', reason);
      });

      // Step 5: Handle incoming transaction updates
      socket.on('transactionUpdate', update => {
        console.log('Received transaction update:', update);
        store.dispatch(receiveTransactionUpdate(update));
      });

      break;

    case DISCONNECT_SOCKET:
      if (socket) {
        socket.disconnect();
      }
      break;

    case SUBSCRIBE_TO_TRANSACTION:
      if (socket) {
        const userRoom = `user-${userId}`;
        socket.emit('subscribeToTransaction', userRoom);
      }
      break;

    case SUBSCRIBE_TO_ORGANIZATION:
      if (socket) {
        const organizationRoom = `organization-${organizationId}`;
        socket.emit('subscribeToOrganization', organizationRoom);
      }
      break;

    case UNSUBSCRIBE:
      if (socket) {
        socket.emit('unsubscribeFromRoom', action.payload);
      }
      break;

    default:
      break;
  }

  return next(action);
};
